var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.515,
    height: 19.267,
    viewBox: "0 0 16.515 19.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hold_time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8819b1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.51,1.5H10V3.335h5.5ZM11.84,13.427h1.835v-5.5H11.84Zm7.367-6.065,1.3-1.3a10.136,10.136,0,0,0-1.294-1.294l-1.3,1.3a8.257,8.257,0,1,0,1.294,1.294Zm-6.45,11.569A6.422,6.422,0,1,1,19.18,12.51,6.418,6.418,0,0,1,12.757,18.932Z",
    transform: "translate(-4.5 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldTime);
export default __webpack_public_path__ + "static/media/hold_time.404fce48e82152e537dc9b29afd7fbf4.svg";
export { ForwardRef as ReactComponent };